<script setup lang="ts">
import { useThrottleFn } from '@vueuse/core'
import Button from '@/core/components/base/Button.vue'
import { useButtonFlipdown, useButtonFlipdownMock } from './ButtonFlipdown'
import LanguageView from '@/core/components/LanguageView.vue'

const { disabled, doFlipDown } = useButtonFlipdown()

const handleTap = useThrottleFn((event: PointerEvent) => {
  doFlipDown()
}, 250)
</script>

<template>
  <Button class="button-flipdown" :disabled @tap="handleTap">
    <template #default><img src="/images/simakatra/arrow-down.gif" /></template>
    <template #disabled><img src="/images/simakatra/arrow-down-disable.png" /></template>
  </Button>
</template>

<style scoped>
.button-flipdown {
  position: absolute;
  left: 653px;
  top: 20px;
}
</style>
